import * as React from 'react';
import styled from 'styled-components';
import {mixinResetBtnCss} from "./btn_mixin";
import {ConstBorderRound, ConstColor} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnDeleteDefault: React.FC<IProps> = (props) => {

    const { ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnDelete = styled(BtnDeleteDefault)`
    ${mixinResetBtnCss}
    padding: 6px 8px;
    cursor: pointer;
    background: ${ConstColor.White};
    border: 1px solid ${ConstColor.Error};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    ::before {
        content: "\\f00d";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        color: ${ConstColor.Error};
    }
`;

export default BtnDelete;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_delete.tsx